import type { RoleCode } from '@/auth/permissions';

/**
 * The local commissioning account policy — §6.5.
 *
 * These live outside `mocks/` because both the sign-in form and the mock
 * handler must apply the same numbers, and the form must not drag the mock
 * into the production bundle to get them.
 */

/** Argon2id server-side, minimum twelve characters. */
export const LOCAL_PASSWORD_MIN_LENGTH = 12;

/** Lock-out after five failures, for fifteen minutes. */
export const LOCAL_SIGNIN_LOCKOUT_FAILURES = 5;
export const LOCAL_SIGNIN_LOCKOUT_MINUTES = 15;

/** Mandatory `expiresAt`, maximum 90 days, defaulted to the handover date. */
export const LOCAL_ACCOUNT_MAX_DAYS = 90;

/**
 * How close to expiry an account starts saying so, in red — on the admin's
 * user list and on the holder's own profile. One constant, because the two
 * screens disagreeing about what "soon" means is exactly the kind of small
 * lie that costs somebody a site visit.
 */
export const LOCAL_ACCOUNT_EXPIRY_WARNING_DAYS = 7;

/**
 * A local account may hold **only** these. Any other assignment is `422`:
 * a long-lived local credential holding a valet or enforcement role would be
 * a way around Entra, which is the whole point of having Entra.
 */
export const LOCAL_ACCOUNT_ALLOWED_ROLES: readonly RoleCode[] = ['commissioning', 'system_admin'];
